import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const ReferenceCodeLookup = ({ onLookup }) => {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const handleLookup = async () => {
    if (!code?.trim()) {
      setError('Please enter a reference code');
      return;
    }

    setLoading(true);
    setError('');
    setResult(null);

    setTimeout(() => {
      const mockResult = {
        code: code?.toUpperCase(),
        floorType: 'Metallic Epoxy',
        baseColor: 'Midnight Blue',
        flakeColor: 'Silver Sparkle',
        room: 'Modern Garage',
        createdAt: new Date(Date.now() - 86400000 * 3)?.toISOString(),
        status: 'active'
      };

      setResult(mockResult);
      setLoading(false);
      if (onLookup) onLookup(mockResult);
    }, 1000);
  };

  const handleClear = () => {
    setCode('');
    setResult(null);
    setError('');
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center gap-3 mb-4">
        <Icon name="Search" size={20} className="text-primary" />
        <h3 className="text-lg font-semibold text-text-primary">Reference Code Lookup</h3>
      </div>
      <p className="text-sm text-text-secondary mb-4">
        Enter a customer's reference code to view their saved design configuration
      </p>
      <div className="flex gap-2 mb-4">
        <Input
          type="text"
          placeholder="Enter reference code (e.g., ABC123XYZ)"
          value={code}
          onChange={(e) => setCode(e?.target?.value?.toUpperCase())}
          error={error}
          className="flex-1"
        />
        <Button
          variant="default"
          onClick={handleLookup}
          loading={loading}
          iconName="Search"
          iconPosition="left"
          iconSize={16}
        >
          Lookup
        </Button>
        {(code || result) && (
          <Button
            variant="outline"
            onClick={handleClear}
            iconName="X"
            iconSize={16}
          >
            Clear
          </Button>
        )}
      </div>
      {result && (
        <div className="bg-muted border border-border rounded-lg p-4 space-y-3">
          <div className="flex items-center justify-between pb-3 border-b border-border">
            <span className="text-sm font-medium text-text-primary">Design Details</span>
            <span className="text-xs px-2 py-1 rounded-full bg-success/10 text-success font-medium">
              {result?.status?.toUpperCase()}
            </span>
          </div>

          <div className="grid grid-cols-2 gap-3 text-sm">
            <div>
              <span className="text-text-secondary">Reference Code:</span>
              <span className="ml-2 text-text-primary font-mono font-semibold">
                {result?.code}
              </span>
            </div>
            <div>
              <span className="text-text-secondary">Created:</span>
              <span className="ml-2 text-text-primary">
                {new Date(result.createdAt)?.toLocaleDateString('en-US', {
                  month: 'short',
                  day: 'numeric',
                  year: 'numeric'
                })}
              </span>
            </div>
            <div>
              <span className="text-text-secondary">Floor Type:</span>
              <span className="ml-2 text-text-primary font-medium">{result?.floorType}</span>
            </div>
            <div>
              <span className="text-text-secondary">Base Color:</span>
              <span className="ml-2 text-text-primary font-medium">{result?.baseColor}</span>
            </div>
            <div>
              <span className="text-text-secondary">Flake Color:</span>
              <span className="ml-2 text-text-primary font-medium">{result?.flakeColor}</span>
            </div>
            <div>
              <span className="text-text-secondary">Room:</span>
              <span className="ml-2 text-text-primary font-medium">{result?.room}</span>
            </div>
          </div>

          <div className="pt-3 border-t border-border">
            <Button
              variant="outline"
              size="sm"
              fullWidth
              iconName="ExternalLink"
              iconPosition="right"
              iconSize={14}
            >
              View Full Design
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReferenceCodeLookup;